<template>
  <div>
    <SysDialog
      v-model="dialog_computed"
      :largura="900"
      titulo="Salvar Análise por Lotes"
      @click:primary="salvar"
      @click:hidden-dialog="fechar"
    >
      <v-layout>
        <v-flex xs7>
          <div class="border-right pr-1">
            <div class="pb-1 text-gray-900 font-weight-medium font-16 d-flex align-center">
              <v-icon :size="20">mdi-format-list-bulleted</v-icon>
              <span class="pl-1">Produtos Selecionados</span>
            </div>

            <v-data-table
              :headers="headers"
              :items="props.produtos_selecionados"
              :items-per-page="-1"
              height="400px"
              class="font-resp-tabela"
              dense
              hide-default-footer
            >
              <template #item.id_grupo="{ item }">
                {{ item.id_grupo }} - {{ item.descricao_grupo }}
              </template>

              <template #item.idproduto="{ item }">
                {{ item.idproduto }} - {{ item.descricao_produto }}
              </template>
            </v-data-table>
          </div>
        </v-flex>

        <v-flex xs5>
          <div class="pb-1 pl-3 text-gray-900 font-weight-medium font-16 d-flex align-center">
            <v-icon :size="20">mdi-format-list-bulleted</v-icon>
            <span class="pl-1">Parâmetros da Análise por Lotes</span>
          </div>

          <v-list>
            <v-list-item dense>
              <v-list-item-content>
                <v-switch
                  v-model="tipo"
                  label="Não usar média e adicionar valor fixo"
                  hide-details
                />
              </v-list-item-content>
            </v-list-item>

            <v-list-item dense>
              <v-list-item-content class="d-flex justify-space-between align-center py-0">
                <v-list-item-title>
                  <span class="font-12 font-weight-medium" v-text="'Valor Fixo'" />
                </v-list-item-title>
                <TextFieldFormatadorDeValor
                  v-model="valor_fixo"
                  :maxDigitos="2"
                  dense
                  :disabled="!tipo"
                  type="number"
                  hide-details="auto"
                  placeholder="Valor fixo"
                  class="text-field-centralizado font-12 w-75"
                  append-outer-icon="mdi-content-save-move-outline"
                  ref="textFieldValorFixoAnalisePorLote"
                  @focus="ev => ev.target.select()"
                >
                </TextFieldFormatadorDeValor>
              </v-list-item-content>
            </v-list-item>

            <v-list-item dense>
              <v-list-item-content class="d-flex justify-space-between align-center py-0">
                <v-list-item-title>
                  <span class="font-12 font-weight-medium" v-text="'Influenciar (%)'" />
                </v-list-item-title>

                <TextFieldFormatadorDeValor
                  v-model="influenciar"
                  :maxDigitos="0"
                  dense
                  :disabled="tipo"
                  type="number"
                  placeholder="%"
                  hide-details="auto"
                  append-outer-icon="mdi-content-save-move-outline"
                  class="text-field-centralizado font-12 w-75"
                  ref="textFieldInfluenciarAnalisePorLote"
                  @focus="ev => ev.target.select()"
                />
              </v-list-item-content>
            </v-list-item>

            <v-list-item dense>
              <v-list-item-content class="d-flex justify-space-between align-center py-0">
                <v-list-item-title>
                  <span class="font-12 font-weight-medium" v-text="'Cobertura Estoque (dias)'" />
                </v-list-item-title>
                <TextFieldFormatadorDeValor
                  v-model="cobertura_estoque"
                  :maxDigitos="0"
                  dense
                  type="number"
                  hide-details
                  placeholder="Cobertura Estoque"
                  class="text-field-centralizado font-12 w-75"
                  append-outer-icon="mdi-content-save-move-outline"
                  ref="textFieldCoberturaEstoqueAnalisePorLote"
                  @focus="ev => ev.target.select()"
                />
              </v-list-item-content>
            </v-list-item>

            <v-list-item dense>
              <v-list-item-content class="d-flex justify-space-between align-center py-0">
                <v-list-item-title>
                  <span class="font-12 font-weight-medium" v-text="'Ponta Estoque (%)'" />
                </v-list-item-title>
                <TextFieldFormatadorDeValor
                  v-model="ponta_estoque_percentual"
                  :maxDigitos="0"
                  dense
                  type="number"
                  hide-details
                  placeholder="%"
                  class="text-field-centralizado font-12 w-75"
                  append-outer-icon="mdi-content-save-move-outline"
                  ref="textFieldPontaEstoquePercentualAnalisePorLote"
                  @focus="ev => ev.target.select()"
                />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-flex>
      </v-layout>
    </SysDialog>
  </div>
</template>

<script setup>
import Api from "@/api/api.js";
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import { logout } from "@/helpers";
import { ref, computed } from 'vue';
import SysInputFormatadorDeValor from "@/components/utils/InputFormatadorDeValor.vue";

const props = defineProps({
  produtos_selecionados: Array,
  dialog: Boolean
});
const emit = defineEmits(['update:produtos-selecionados', 'update:dialog-aplicar-em-massa']);
const influenciar = ref(0);
const cobertura_estoque = ref(60);
const ponta_estoque_percentual = ref(50);
const valor_fixo = ref(0);
const tipo = ref(false);
const headers = [
  { text: 'Grupo', value: 'id_grupo' },
  { text: 'Produto', value: 'idproduto' },
]

const dialog_computed = computed({
  get() {
    return props.dialog;
  },
  set(novoValor) {
    emit('update:dialog-aplicar-em-massa', novoValor);
  }
});

function salvar() {
  const params = {
    produtos: props.produtos_selecionados.map(item => ({ id_grupo: item.id_grupo, id_produto: item.idproduto })),
    tipo_ponto_pedido: tipo.value,
    ponto_pedido_fixo: valor_fixo.value,
    ponto_pedido_percentual_influencia: influenciar.value,
    cobertura_estoque: cobertura_estoque.value,
    ponta_estoque_percentual: ponta_estoque_percentual.value,
  }

  Api.post("/compras/produtos/analise-por-lotes/salvar-parametrizacao", params)
    .then(() => {
      emit('update:produtos-selecionados');
      dialog_computed.value = false;
    })
    .catch(logout);
}

function fechar() {}
</script>

<style scoped>
.border-right {
  border-right: 1px solid #cbcbcb;
}
</style>
